(ns rothko.form2.radio.component
  (:require [reagent.core :as r]
            [rothko.dom.event :as dom]
            [rothko.form2.component :as form]
            [rothko.form2.label.component :as label]
            [rothko.form2.validation-message.component :as validation-message]))

(defn classes-for-highlighting
  [highlight options option-value]
  (when highlight
    [:highlighting
     (when (= option-value (-> options first :value))
       :first-radio-option)
     (when (= option-value (-> options last :value))
       :last-radio-option)
     (when (some-> highlight ::form/value (= option-value))
       :highlight-primary)
     (when (and (::neighbours? highlight)
                (some-> highlight ::form/value dec (= option-value)))
       :highlight-left-neighbour)
     (when (and (::neighbours? highlight)
                (some-> highlight ::form/value inc (= option-value)))
       :highlight-right-neighbour)]))

(defn- option
  [group-disabled?
   {:keys [::form/name ::form/initial-value ::form/set-value! ::highlight ::options]
    :as field-props}
   {:keys [disabled? label data-ordinal]
    option-value :value
    :as option}]
  [:div
   {:class (concat [:radio__option]
                   (classes-for-highlighting highlight options option-value))}
   [:input
    {:type :radio
     :id name
     :name name
     :on-change (dom/dom-event set-value!)
     :value option-value
     :data-ordinal data-ordinal ; Allow text-valued options to be selected by ordinal.
     :disabled (or group-disabled? disabled?)
     :defaultChecked (= option-value initial-value)}]
   ;; TODO rothko#214 should/can we use label component here?
   [:label {:for name} label]])

;; TODO rothko#210 use defcomp for input and assert props there
(defn field*
  [{:keys [appearance
           tab-index
           ::form/disabled?
           ::form/description
           ::form/label
           ::form/value
           ::highlight
           ::options]
    :as field-props}]
  (when (not-empty options)
    [:div.radio.tab-item
     {:tab-index tab-index}
     [:div.radio__container
      {:class (cond-> appearance highlight (conj :highlighting))}
      [label/component field-props]
      ;; TODO rothko#213 description component
      (when description
        [:p description])
      (into [:div.radio__options-container
             ;; TODO rothko#229 disabled? should be an appearance
             (cond-> {:class [(when disabled? :disabled)]}
               disabled? (assoc :disabled true))]
            (map (partial option disabled? field-props)
                 options))]
     [validation-message/component field-props]]))

(defn- options-attribute
  "Returns the sequence of options in which each has been updated to ensure it
   contains required mappings of keys to values."
  [options]
  (map-indexed (fn [idx {:keys [label value] :as option}]
                 (assoc option
                        :label (or label value)
                        :data-ordinal (str (inc idx))))
               options))

(defn field
  [field-props]
  (let [field-props (update field-props ::options options-attribute)]
    [field* field-props]))
